import React, { useState, useEffect, useRef } from 'react';
import { useHistory } from 'react-router-dom';
import Modal from 'antd/lib/modal/Modal';

const LeavePageModal = () : JSX.Element => {
  const {
    replace,
    block,
  } = useHistory();
  // const [lastLocationName, setLastLocationName] = useState(location.pathname);
  const [leaveModalVisible, setLeaveModalVisible] = useState(false);
  const [lastLocation, setLastLocation] = useState('');
  const [confirmedNavigation, setConfirmedNavigation] = useState(false);
  const ref = useRef<() => boolean | void>();

  useEffect(() => {
    ref.current = block(({ pathname }) => {
      setLastLocation(pathname);

      setLeaveModalVisible(true);
      return false;
    });

    return () => {
      if (ref.current) {
        ref.current();
      }
    };
  }, []);

  useEffect(() => {
    if (confirmedNavigation && lastLocation) {
      replace(lastLocation);
    }
  }, [lastLocation, confirmedNavigation]);

  const onConfirm = () => {
    setLeaveModalVisible(false);
    setConfirmedNavigation(true);
    ref.current = block(() => undefined);
  };

  const onCancel = () => {
    setLeaveModalVisible(false);
  };

  return (
    <Modal
      title={null}
      closable={false}
      centered
      visible={leaveModalVisible}
      wrapClassName="wrapper"
      okText="Leave"
      onOk={onConfirm}
      onCancel={onCancel}
    >

      <div className="ant-modal-body__content">
        <div className="ant-modal-body__content__title">Leave the page?</div>
        <span className="ant-modal-body__content__text">Changes that you made may not be saved.</span>
      </div>
    </Modal>
  );
};

export default LeavePageModal;
